import { Component, OnInit, Input, Output, ViewChild, EventEmitter, forwardRef } from '@angular/core';

/* [dj]Query builder: customization interfaces */
import { QueryBuilderClassNames, QueryBuilderConfig } from 'ngx-angular-query-builder';
import { MetadataService } from 'app/BaseFramework/core/http/metadata.service';
import { InteractService } from 'app/BaseFramework/core/services/interact/interact.service';
import { QuillEditorComponent } from 'ngx-quill';
/*
* [dj]Finalized from:
* https://github.com/zebzhao/Angular-QueryBuilder
* https://zebzhao.github.io/Angular-QueryBuilder/demo/
* http://niklr.github.io/angular-query-builder/https://ng.ant.design/version/8.5.x/components/mention/en
* https://github.com/zebzhao/Angular-QueryBuilder
* */


/*
* [dj]Editor with @mention support: Quill
* =============================================
* NB: Quill Upp Implementation used below
* Alternatively, ZORRO's MENTION can also be used for a more minimal approach
* 
*/
/*  QUILL Editor  */
import Quill from 'quill';
// const parchment = Quill.import('parchment');
// const block = parchment.query('block');
// block.tagName = 'DIV';
// Quill.register(block, true);
/* Quill Extras */
import {Mention,MentionBlot} from "quill-mention";
// const MentionBlot=Mention;
Quill.register({ "blots/mention": MentionBlot, "modules/mention": Mention });
import { split, startsWith, truncate, values } from 'lodash';
import { CommonUtilty } from 'app/BaseFramework/core/utilities/commonUtility';
import { LookupDataService } from 'app/BaseFramework/core/http/lookupdata.service';
import { ControlValueAccessor } from '@angular/forms';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { environment } from 'environments/environment';
import { DataTransformService } from 'app/ViewModules/shared-services';
import { AppMetadataHandler } from 'app/BaseFramework/configs/app-metadata.handler';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AsyncSubject } from 'rxjs';
import { ViewEncapsulation } from '@angular/core';
/* Quill Ngx */


@Component({
  selector: 'app-pc-expression-builder',
  templateUrl: './pc-expression-builder.component.html',
  styleUrls: ['./pc-expression-builder.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PcExpressionBuilderComponent),
      multi: true
    }
  ],
  encapsulation: ViewEncapsulation.None
})

export class PcExpressionBuilderComponent implements OnInit, ControlValueAccessor {


  /**
  * 
  * ControlValueAccessor Implementation
  */
  writeValue(obj: any): void {
    this.expression = obj
  }
  propagateChange = (_: any) => { };
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void { }

  @Input() viewMode: 'normal' | 'micro' = 'normal';
  @Input() mode: 'expression' | 'query' = 'expression';
  @Input() disableEdit: boolean = false
  @Input() externalAllowedMathOperators = []
  @Output() componentOutput = new EventEmitter<any>();
  @Output() validationObject = new EventEmitter<any>();
  @Output() expressionReadableText = new EventEmitter<any>();
  itemType = 'default'
  returnItemPrefix = 'Return'

  private _outputLookup: any = 'claimDecisionCd';
  @Input()
  public get outputLookup(): any {
    return this._outputLookup;
  }
  public set outputLookup(value: any) {
    this._outputLookup = value;
    this.fetchAndSetOutputLookup(value);
  }

  public get steps() {
    return this.dataTransformService._transientComputationStepData;
  }


  @Input() privilege;
  lookupValues = []

  constructor(public interactService: InteractService,
    private metadataService: MetadataService,
    private commonUtilty: CommonUtilty,
    private lookupDataService: LookupDataService,
    private dataTransformService: DataTransformService,
    public appMetadataHandler: AppMetadataHandler,
    public msg: NzMessageService) { }

  fetchedVocabularyLog = []
  VocabularyRawData
  private _prefixStore = [];
  public get prefixStore() {
    return [this.returnItemPrefix, ...this._prefixStore];
  }
  public set prefixStore(value) {
    this._prefixStore = value;
  }
  private fetchAndSetOutputLookup(value: any, vocabularyMetaData?, prefix?) {
    if (value) {
      Array.isArray(this.fetchedVocabularyLog) && vocabularyMetaData && this.fetchedVocabularyLog.push(vocabularyMetaData)
      let lookupList = [...this.lookupValues];
      this.lookupDataService.getLookup(value).subscribe(e => {
        let anyAndNullValues = [
          { lookupKey: 'ANY', lookupValue: 'Any' },
          { lookupKey: 'NULL', lookupValue: 'Null' },
          { lookupKey: 'EMPTY', lookupValue: 'Empty' },
        ]

        if (this.commonUtilty.isArrayIterable(e)) {
          e = [...e, ...anyAndNullValues]
        }
        else {
          e = [...anyAndNullValues]
        }

        prefix && (this.prefixStore = this.commonUtilty.uniquePushInArray(this.prefixStore, prefix))
        e.forEach(lookupItem => {
          let item = {
            id: lookupItem.lookupKey,
            value: `${prefix ? prefix : this.returnItemPrefix}: ${lookupItem.lookupValue}`,
            type: this.itemType,
            itemType: 'LOOKUP',
            metaData: this.commonUtilty.deepCopy(lookupItem),
            vocabularyMetaData: this.commonUtilty.deepCopy(vocabularyMetaData),
            previousCharterAllowed: [...this._mathOperators.map(e => e.value)]
          };
          this.lookupValues = this.commonUtilty.uniquePushInArray(lookupList, item, 'id');
        });

      });
    }
  }

  ngOnInit(): void {
    this.fetchAllVocabularies();
    this.fetchExpressionMetadata()

    // this.fetchAndSetOutputLookup(this.outputLookup);
  }

  private fetchAllVocabularies() {
    let caller: AsyncSubject<any> = new AsyncSubject<any>();
    //this.metadataService.fetchVocabulariesForLOB('ALL').subscribe(resp => {
    let resp = this.commonUtilty.deepCopy(this.metadataService.allVocabularies)
    if (this.commonUtilty.isArrayIterable(resp)) {
      this.VocabularyRawData = this.commonUtilty.deepCopy(resp);
      this.allVocabularies = resp.map(e => {
        let item = {
          id: e.vocabularyCd,
          itemType: 'VOCABULARY',
          value: e.vocabularyName,
          displayName : e.displayName,
          type: 'default',
          description: e.description,
          metaData: JSON.stringify(e),
          vocabularyMetaData: JSON.stringify(e),
        };
        this.allVocabulariesMap[`#VC_${e.vocabularyCd}`] = e.displayName ? e.displayName : e.vocabularyName ;
        return item;
      });

      setTimeout(() => {
        caller.next({ status: true });
        caller.complete();
      }, 200);

    }
    return caller
    //});
  }

  expressionMetaData
  private fetchExpressionMetadata() {
    let caller: AsyncSubject<any> = new AsyncSubject<any>();
    this.metadataService.fetchExpressionMetaData().subscribe(resp => {
      if (this.commonUtilty.isArrayIterable(resp)) {
        this.functions = this.extractFunctionListFromMetadata(resp)
        this.expressionMetaData = this.commonUtilty.deepCopy(resp)
        // let doesFunctionHaveSpaces = this._doesFunctionHaveSpaces(this._expression_text);
        let removedSpecialCharacters = this.removedSpecialCharacters(this._expression_text, " ");
        this._validationObject = this.validateExpression(removedSpecialCharacters)
        this.validationObject.emit(this._validationObject)
        caller.next({ status: true });
        caller.complete();
      }
      return caller
    });
  }


  private removedSpecialCharacters(msg, replaceWith?) {
    if (msg)
      return msg.replace(/[\u200B-\u200D\uFEFF]/g, replaceWith || '');
    else
      return msg
  }

  private extractFunctionListFromMetadata(resp: any) {
    if (this.commonUtilty.isArrayIterable(resp)) {
      return resp.filter(e => e && e.metaDataType && e.metaDataType.includes('FUNCTION')).map(item => {
        let output = {
          id: item.operatorCd,
          itemType: item.metaDataType,
          value: item.operatorDesc,
          type: 'default',
          description: item.operatorDesc,
          metaData: JSON.stringify(item)
        };
        return output;
      });
    }
  }

  ngAfterViewInit() {
  }


  functionTypes = [
    { id: "#FN_NumberFunctionUtility", value: "Number Function", type: this.itemType, itemType: 'MATHEMATICAL_FUNCTION' },
    { id: "#FN_DateTimeFunctions", value: "Date Function", type: this.itemType, itemType: 'DATE_FUNCTION' },
  ]

  useFragment = false;
  get functionNameEndFragment() {
    if (this.useFragment)
      return this.functionTypes.find(e => e.id.slice(e.id.length - 4))
    else return 'Functions'
  }

  get numberFunctionNameEndFragment(){
    return 'NumberFunctionUtility'
  }

  get dateFunctionNameEndFragment(){
    return 'DateTimeFunctions'
  }

  functions = []
  private _functionsMap;
  public get functionsMap() {
    return this.commonUtilty.convertArrayToMap(this.functions, 'id');
  }
  public set functionsMap(value) {
    this._functionsMap = value;
  }

  logicalOperators = [
    { id: 'IF (', value: "IF (", type: this.itemType, itemType: 'LOGICALOPERATOR', previousCharterAllowed: ["null", "(", "undefined"] },
    { id: "ELSE (", value: "ELSE (", type: this.itemType, itemType: 'LOGICALOPERATOR', previousCharterAllowed: ['VALUE', ")"] },
    // { id: "ELSE IF (", value: "ELSE IF (", type: this.itemType, itemType: 'LOGICALOPERATOR', previousCharterAllowed: ['VALUE', ")"] },
    { id: "THEN (", value: "THEN (", type: this.itemType, itemType: 'LOGICALOPERATOR', previousCharterAllowed: ['VALUE', ")"] },
    { id: "&&", value: "&&", type: this.itemType, itemType: 'LOGICALOPERATOR', previousCharterAllowed: ['VALUE', ")"] },
    { id: "||", value: "||", type: this.itemType, itemType: 'LOGICALOPERATOR', previousCharterAllowed: ['VALUE', ")"] },
    { id: "NOT", value: "NOT", type: this.itemType, itemType: 'LOGICALOPERATOR', previousCharterAllowed: ['VALUE', ")"] },
    { id: "CONTAINS", value: "CONTAINS", type: this.itemType, itemType: 'LOGICALOPERATOR', previousCharterAllowed: ['VALUE', ")"] },
  ]

  public get logicalOperatorsMap() {
    return this.commonUtilty.convertArrayToMap(this.logicalOperators, "value")
  }

  private _mathOperators = [
    { id: ">=", value: ">=", type: this.itemType, itemType: 'MATHEMATICAL_OPERATOR', priority: 6 },
    { id: "==", value: "==", type: this.itemType, itemType: 'MATHEMATICAL_OPERATOR', priority: 7 },
    { id: "<=", value: "<=", type: this.itemType, itemType: 'MATHEMATICAL_OPERATOR', priority: 8 },
    { id: "!=", value: "!=", type: this.itemType, itemType: 'MATHEMATICAL_OPERATOR', priority: 9 },
    { id: "+", value: "+", type: this.itemType, itemType: 'MATHEMATICAL_OPERATOR', priority: 10 },
    { id: "-", value: "-", type: this.itemType, itemType: 'MATHEMATICAL_OPERATOR', priority: 11 },
    { id: "*", value: "*", type: this.itemType, itemType: 'MATHEMATICAL_OPERATOR', priority: 12 },
    { id: "/", value: "/", type: this.itemType, itemType: 'MATHEMATICAL_OPERATOR', priority: 13 },
    { id: "=", value: "=", type: this.itemType, itemType: 'MATHEMATICAL_OPERATOR', priority: 7 },
    // { id: "=", value: "=", type: this.itemType, itemType: 'MATHEMATICAL_OPERATOR', priority: 3 },
    { id: "(", value: "(", type: this.itemType, itemType: 'MATHEMATICAL_OPERATOR', priority: 2 },
    { id: ")", value: ")", type: this.itemType, itemType: 'MATHEMATICAL_OPERATOR', priority: 1 },
    { id: ">", value: ">", type: this.itemType, itemType: 'MATHEMATICAL_OPERATOR', priority: 4 },
    { id: "<", value: "<", type: this.itemType, itemType: 'MATHEMATICAL_OPERATOR', priority: 5 },
    { id: "_", value: "_", type: this.itemType, priority: 14, hidden: true },
    { id: ";", value: ";", type: this.itemType, priority: 15, hidden: true },
    { id: ".", value: ".", type: this.itemType, priority: 16, hidden: true },
    { id: ",", value: ".", type: this.itemType, priority: 16, hidden: true },
  ];

  public get mathOperators() {
    if (this.commonUtilty.isArrayIterable(this.externalAllowedMathOperators)) {
      let output = this.externalAllowedMathOperators.map(e => {
        let found = this._mathOperators.find(d => e == d.value)
        if (found)
          return found
        else
          return { id: e, value: e, type: this.itemType, itemType: 'MATHEMATICAL_OPERATOR', priority: 1 }
      }).filter(e => !e['hidden'])
      return this.commonUtilty.sortObject('priority', output, 'asc')
    }
    return this.commonUtilty.sortObject('priority', this._mathOperators, 'asc')
  }

  public get allMathOperators() {
    if (this.commonUtilty.isArrayIterable(this.externalAllowedMathOperators)) {
      let output = this.externalAllowedMathOperators.map(e => {
        let found = this._mathOperators.find(d => e == d.value)
        if (found)
          return found
        else
          return { id: e, value: e, type: this.itemType, itemType: 'MATHEMATICAL_OPERATOR', priority: 1 }
      })
      return this.commonUtilty.sortObject('priority', output, 'asc')
    }
    return this.commonUtilty.sortObject('priority', this._mathOperators, 'asc')
  }

  public set mathOperators(value) {
    this._mathOperators = value;
  }

  public get mathOperatorsMap() {
    return this.commonUtilty.convertArrayToMap(this._mathOperators, "value")
  }

  /* Quill Editor */
  // @ViewChild(QuillEditorComponent, { static: true }) editor: QuillEditorComponent
  @ViewChild('editor') editor: QuillEditorComponent;
  allVocabularies = []
  allVocabulariesMap = []
  // configData = this.appMetadataHandler.configDataJSON
  timesOpened = 0;
  toolbarOptions = {
    container: [
      [{ 'header': [2, 3, 4, 5, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['link'],//'image',
      ['video'],
      ['clean'], // remove formatting
      //[{ 'header': 1 }, { 'header': 2 }],               // custom button values
      //[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      //[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      //['code-block'],
      //[{ 'direction': 'rtl' }],                         // text direction
      //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      //[{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      //[{ 'font': [] }],
      //[{ 'align': [] }],
    ],
  };
  modules = {
    toolbar: this.toolbarOptions,
    mention: {
      allowedChars
        : /^[A-Za-z\sÅÄÖåäö^=('<>*.)+-/==>=<=!=$#&|@;]*$/,
      mentionDenotationChars: ["@", "#", "$"],
      fixMentionsToQuill: true,
      dataAttributes: ['id', 'value', 'type', 'denotationChar', 'link', 'target', 'itemType', 'metaData', 'description', 'vocabularyMetaData', 'previousCharterAllowed'],
      source: (searchTerm, renderList, mentionChar) => {
        let itemType = "default";
        let dataRender = []
        let simulation = false
        searchTerm && (searchTerm = searchTerm.toLowerCase()) && (searchTerm = searchTerm.trim())

        if (mentionChar === "@") {
          dataRender = this.OperatorAndVocabularyHandler(searchTerm);
        }
        else if (mentionChar === "#") {
          // let allItems = [...this.getFunctions(searchTerm), ...this.getFunctionTypes(searchTerm)]
          let allItems = [...this.getFunctions(searchTerm, true)]
          dataRender = [...allItems]
        }
        else if (mentionChar === "$") {
          // let allItems = [...this.getFunctions(searchTerm), ...this.getFunctionTypes(searchTerm)]
          let allItems = [...this.getStepVariables(searchTerm, "")]
          dataRender = [...allItems]
        }

        renderList(dataRender, searchTerm);

      },
      onSelect: (item, insertItem) => {
        const editor = this.editor.quillEditor as Quill;
        const prefixToRemove = this.prefixStore.filter(e => item.value.includes(e))
        this.resetHelpInfo()
        if (this.mathOperators)
          if (item) {
            item['denotationChar'] = ""
          }
        if (item.value == 'IF') {
          // let expressionArray = ["IF", "(", "TYPE-CONDITION", ")", "THEN", "(", "TYPE-ACTION", ")", "ELSE", "(", "TYPE-ACTION", ")"]
          let expressionArray = ["IF", "(",]
          expressionArray.forEach(e => {
            item.value = e
            this.selectAndAdd(insertItem, item);
          })
        }

        else if (item.value == 'THEN') {
          // let expressionArray = ["THEN", "(", "TYPE-ACTION", ")", "ELSE", "(", "TYPE-ACTION", ")"]
          let expressionArray = ["THEN", "(",]
          expressionArray.forEach(e => {
            item.value = e
            this.selectAndAdd(insertItem, item);
          })
        }

        else if (item.value == 'ELSE') {
          let expressionArray = ["ELSE", "(",]
          expressionArray.forEach(e => {
            item.value = e
            this.selectAndAdd(insertItem, item);
          })
        }

        else if (item.value == 'ELSE IF') {
          let expressionArray = ["ELSE IF", "(",]
          expressionArray.forEach(e => {
            item.value = e
            this.selectAndAdd(insertItem, item);
          })
        }

        // else if (item.value == 'AND') {
        //   item.value = "&&"
        //   this.selectAndAdd(insertItem, item);
        // }

        // else if (item.value == 'OR') {
        //   item.value = "||"
        //   this.selectAndAdd(insertItem, item);
        // }

        else if (item.itemType == 'VOCABULARY') {
          let metaData = item['metaData'] ? JSON.parse(item['metaData']) : null
          if (!environment.production) metaData['lookupCd'] = (metaData && !metaData['lookupCd'] && item.id.includes('ender')) ? 'genderCd' : metaData['lookupCd']
          if (metaData && metaData['lookupCd']) {
            this.fetchAndSetOutputLookup(metaData['lookupCd'], metaData, 'Value')
          }
          else {
            if (this.msg && metaData && metaData['dataTypeCd'] == "COMBO" && !metaData['lookupCd'])
              this.msg.warning(`No Lookup mapped for ${metaData.displayName ? metaData.displayName : metaData.vocabularyName}`)
          }
          item.value = `#VC_${item.id} `
          this.setHelperInfo(`'${metaData.displayName ? metaData.displayName : metaData.vocabularyName}'(${item.value}) Vocabulary used of type '${metaData.dataTypeCd}'. ${metaData.description}`)
          this.selectAndAdd(insertItem, item);
        }

        else if (item.itemType.includes('FUNCTION')) {
          let metaData = item['metaData'] ? JSON.parse(item['metaData']) : null
          let functionTypesMap = this.commonUtilty.convertArrayToMap(this.functionTypes, 'itemType')
          let prefix = functionTypesMap[item.itemType].id
          item.value = `${prefix}('${item.id}',`
          this.selectAndAdd(insertItem, item);
          this.setHelperInfo(metaData ? metaData.expressionHelp : null)
        }

        else if (item.itemType == 'LOOKUP' && item.value && this.commonUtilty.isArrayIterable(prefixToRemove)) {
          prefixToRemove.forEach(e => item.value = item.value.replace(e + ": ", ''))
          item.value = `'${item.id}'`
          this.selectAndAdd(insertItem, item);
        }

        else if (item.value && this.commonUtilty.isArrayIterable(prefixToRemove)) {
          prefixToRemove.forEach(e => item.value = item.value.replace(e + ": ", ''))
          item.value = `'${item.value}'`
          this.selectAndAdd(insertItem, item);
        }

        else {
          this.selectAndAdd(insertItem, item);
        }


        editor.insertText(editor.getLength() - 1, '', 'user'); /* necessary as @mention triggers as 'api' and not as 'user' */
      },
      renderItem: (item, searchTerm) => {
        return `${item.displayName ? item.displayName : item.value}`;
      },
      isolateCharacter: true, /*  denotation character(s) isolation:: this allows user to type emails etc; */
      minChars: 0, maxChars: 5000,
      onOpen: () => { },
      onClose: () => { }
    },
  };

  currentHelper

  setHelperInfo(msg) {
    this.currentHelper = msg
  }

  resetHelpInfo() {
    this.currentHelper = null
  }

  private OperatorAndVocabularyHandler(searchTerm: any) {
    let allItems;
    let text = this.removedSpecialCharacters(this._expression_text);
    let lastSubstring = this.getLastSubstring(text)
    if (!(text && text.trim()) && !!!searchTerm) {
      allItems = [{ id: 'EMPTY', value: 'Type Vocabulary/Operator to search...', disabled: true }];
    }
    // else if (!(text && text.trim()))
    //   allItems = [...this.getLogicalOperators(searchTerm, lastSubstring), ...this.allVocabularies];
    else if (!!!searchTerm) {
      if (lastSubstring && lastSubstring.includes('#VC_'))
        allItems = [...this.getMathsOperators(searchTerm, lastSubstring)];
      else if (lastSubstring && this.mathOperatorsMap[lastSubstring]) {
        // Removed the StepVariables as per JIRA issues PF-1062
        // allItems = [...this.getOutputValues(searchTerm, lastSubstring), ...this.getStepVariables(searchTerm, lastSubstring)];
        allItems = [...this.getOutputValues(searchTerm, lastSubstring)];
      }
    }
    else
      allItems = [...this.getMathsOperators(searchTerm, lastSubstring), ...this.getOutputValues(searchTerm, lastSubstring), ...this.getLogicalOperators(searchTerm, lastSubstring), ...this.getStepVariables(searchTerm, lastSubstring), ...this.getVocabularies(searchTerm)];
    let topResultNumber;
    try {
      topResultNumber = this.appMetadataHandler.configDataJSON['APPConstants'].resultCountForForExpressionBuilder;
    } catch {
      // previous value was 10, increased to 30 because all the filtered results were not displaying in the list.
      topResultNumber = 30;
    }
    let dataRender = this.search(allItems, 'value', searchTerm, topResultNumber);
    if (!this.commonUtilty.isArrayIterable(dataRender) && !!searchTerm) {
      dataRender = [{ id: 'EMPTY', value: 'No Result Found', disabled: true }]
    }
    else if (!this.commonUtilty.isArrayIterable(dataRender) && !!!searchTerm) {
      dataRender = [{ id: 'EMPTY', value: 'Type Vocabulary/Operator to search...', disabled: true }]
    }

    return dataRender;
  }

  get lastInsertedItem() {
    if (this.commonUtilty.isArrayIterable(this.insertedItemsList)) {
      return this.insertedItemsList[this.insertedItemsList.length - 1]
    }
  }
  insertedItemsList: any[] = []

  private selectAndAdd(insertItem: any, item: any) {
    insertItem(item);
    this.insertedItemsList.push(item)
  }

  getFunctionTypes(searchTerm) {
    let output = []
    let removedSpecialCharacters = this.removedSpecialCharacters(this._expression_text, "");
    if (this.commonUtilty.isArrayIterable(this.functionTypes)) {
      let lastOperation
      try {
        lastOperation = this.commonUtilty.splitMulti(removedSpecialCharacters).filter(e => e && !e.includes('(') && !e.includes(',')).pop();
      } catch (e) {

      }
      let lastSubstring = this.getLastSubstring(removedSpecialCharacters)
      let lastChar = lastSubstring ? lastSubstring.slice(-2) : null;
      if (lastOperation && !lastOperation.includes('#FN_')) {
        if (!!searchTerm) {
          output = this.functionTypes.filter(e => e.value && e.value.toLowerCase().includes(searchTerm))
        }
        else {
          output = this.functionTypes
        }
      }
    }

    return output
  }

  getVocabularies(searchTerm) {
    let output = []
    if (this.commonUtilty.isArrayIterable(this.allVocabularies)) {
      if (!!searchTerm) {
        let searchRegexp
        try {
          searchRegexp = new RegExp(searchTerm, 'i');
          output = this.allVocabularies.filter(e => searchRegexp.test((e.displayName ? e.displayName : e.value))).slice(0, 50)
        }
        catch { }
        // let allSearchTerms = this.commonUtilty.splitMulti(searchTerm);
        // if (this.commonUtilty.isArrayIterable(allSearchTerms) && this.commonUtilty.isArrayIterable(this.allVocabularies)) {
        //   this.allVocabularies.forEach((vocab, index) => {
        //     let score = allSearchTerms.reduce((acc, e) => {
        //       if (vocab && vocab.value && vocab.value.includes(e)) {
        //         acc += 1
        //       }
        //       return acc
        //     }, 0)
        //     this.allVocabularies[index]['searchScore'] = score
        //   })
        // }
        // output = this.commonUtilty.sortObject('searchScore', this.allVocabularies, 'desc').slice(0, 50);

      }
      else {
        output = this.allVocabularies
      }
    }

    return output

  }

  getFunctions_Old(searchTerm, isWithoutFunctionalType?) {
    let output = []
    let removedSpecialCharacters = this.removedSpecialCharacters(this._expression_text, "");
    if (this.commonUtilty.isArrayIterable(this.functionTypes)) {
      let lastOperation
      try {
        lastOperation = this.commonUtilty.splitMulti(removedSpecialCharacters).filter(e => e && !e.includes('(')).pop();
      } catch (e) {

      }
      if (lastOperation && (isWithoutFunctionalType || lastOperation.includes('#FN_'))) {
        let lastSubstring = this.getLastSubstring(removedSpecialCharacters)
        let lastChar = lastSubstring ? lastSubstring.slice(-2) : null;
        if (!!searchTerm) {
          output = this.functions.filter(e => e.value && e.value.toLowerCase().includes(searchTerm))
        }
        else {
          if (lastOperation.includes('Number') || lastOperation.includes('Math'))
            output = this.functions.filter(e => e.itemType && e.itemType.includes('MATHEMATICAL_FUNCTION'))
          else if (lastOperation.includes('Number'))
            output = this.functions.filter(e => e.itemType && e.itemType.includes('DATE_FUNCTION'))
          else
            output = this.functions
        }
      }
      else
        output = this.functions
    }

    return output
  }

  getFunctions(searchTerm, isWithoutFunctionalType?) {
    let output = []
    if (!!searchTerm) {
      output = this.functions.filter(e => e.value && e.value.toLowerCase().includes(searchTerm))
    }
    else {
      output = this.functions
    }
    return output
  }

  getLogicalOperators(searchTerm, lastSubstring) {
    let output = []
    if (this.commonUtilty.isArrayIterable(this.logicalOperators)) {
      let lastChar = lastSubstring ? lastSubstring.slice(-2) : null;
      if (!!searchTerm) {
        output = this.logicalOperators.filter(e => e.value && e.value.toLowerCase().includes(searchTerm))
      }
      else {
        output = this.logicalOperators.filter(e => {
          let allowedChars = e.previousCharterAllowed.join("")
          return allowedChars.includes(lastChar + "")
        })
      }
    }

    return output
  }

  getMathsOperators(searchTerm, lastSubstring) {
    let output = []

    if (this.commonUtilty.isArrayIterable(this.mathOperators)) {
      let lastChar = lastSubstring ? lastSubstring.slice(-2) : null;
      // if (lastSubstring && lastSubstring.includes('#VC_')) {
      //   output = this.mathOperators.filter(e => e.value == '==')
      // }
      // else 
      if (!!searchTerm) {
        output = this.mathOperators.filter(e => e.value && e.value.toLowerCase().includes(searchTerm))
      }
      else {
        output = this.mathOperators.filter(e => {
          let disallowedChars = this.AllLogicalAndMathOperators.join("")
          return !!!disallowedChars.includes(lastChar + "")
        })
      }
    }

    return output
  }

  getOutputValues(searchTerm, lastSubstring) {
    let output = []
    if (this.commonUtilty.isArrayIterable(this.lookupValues)) {
      let lastChar = lastSubstring ? lastSubstring.slice(-2) + "" : null;
      let condition1 = this._expression_text ? (this._expression_text.includes("THEN (") || this._expression_text.includes("ELSE (") || this._expression_text.includes("ELSE IF (")) : false
      let condition2 = this.lastInsertedItem ? this.lastInsertedItem.itemType == 'MATHEMATICAL_OPERATOR' : false;
      let removedSpecialCharacters = this.removedSpecialCharacters(this._expression_text, "")
      if (searchTerm) {
        try {
          output = this.lookupValues.filter(e => e.value && e.value.toLowerCase().includes(searchTerm) && e.vocabularyMetaData && removedSpecialCharacters.includes(e.vocabularyMetaData.vocabularyCd))
        } catch (e) { }
      }
      else {
        try {
          let lastVocab = this.commonUtilty.splitMulti(removedSpecialCharacters).filter(e => e && e.includes('#VC_')).map(t => t ? t.replace('#VC_', '') : t).pop();
          output = this.lookupValues.filter(e => {
            let condition = e.vocabularyMetaData && e.vocabularyMetaData.vocabularyCd == lastVocab
            return condition
          });
        }
        catch {
          output = []
        }
      }
      // TODO Advanced Filter. Do Not Remove the commented code.
      // else if (condition1 || condition2) {
      //   output = this.lookupValues.filter(e => {
      //     //Ninad: Lookup Filtration can be added here for more complex scenarios
      //     return true
      //   })
      // }
    }
    return output
  }

  getStepVariables(searchTerm, lastSubstring) {
    let output = []
    if (this.commonUtilty.isArrayIterable(this.steps)) {
      let lastChar = lastSubstring ? lastSubstring.slice(-2) : null;
      let stepVariables = this.steps.map(step => {
        if (this.commonUtilty.isArrayIterable(step.ruleActionList) && step.ruleActionList[0].action && !step.ruleActionList[0].actionForCd) {
          let item = {}
          item['id'] = step.ruleActionList[0].action
          item['itemType'] = 'STEPVARIABLE'
          item['value'] = step.ruleActionList[0].action
          item['type'] = 'default'
          item['description'] = step.ruleActionList[0].action
          item['metaData'] = JSON.stringify(step)
          return item
        }
      })
      if (!!searchTerm) {
        output = stepVariables.filter(e => e && e.value && e.value.toLowerCase().includes(searchTerm))
      }
      else {
        output = stepVariables
      }
    }

    return output.filter(e => e)
  }

  get AllLogicalAndMathOperators() {
    let logical = this.logicalOperators.map(e => e.value)
    let maths = this.mathOperators.map(e => e.value)
    return [...logical, ...maths]
  }

  getLastSubstring(str) {
    let output = this.commonUtilty.splitMulti(str)
    if (this.commonUtilty.isArrayIterable(output)) {
      output = output.filter(e => e)
      return output.pop()
    }
    else
      return null
  }

  /* Quill Editor's Emits */
  editorOnBlur(e) {
    /* e.editor: Quill, e.source: string ("user") */
    //let content = this.content.content;
    this.EmitComponentOutput('blur');
  }
  isParsing = false;
  editorOnContentChange(e) {
    // console.log("Expression", e.text)
    this.EmitComponentOutput('blur');
    this.isParsing = true;
    setTimeout(() => { this.isParsing = false; }, 750);
  }

  search(list, key, value, maxResultItems?: number) {
    if (!maxResultItems) maxResultItems = 50
    if (this.commonUtilty.isArrayIterable(list) && key && value) {
      let startWithSearchTerm = [], containsSearchTerm = []
      let searchResult = []
      list.forEach(e => {
        if (searchResult.length <= maxResultItems) {
          if (e && (e['displayName'] ? e['displayName'] : e[key]) &&(e['displayName'] ? e['displayName'] : e[key]).toLowerCase().startsWith(value.toLowerCase())) {
            startWithSearchTerm.push(e)
          }
          if (e &&(e['displayName'] ? e['displayName'] : e[key]) &&(e['displayName'] ? e['displayName'] : e[key]).toLowerCase().includes(value.toLowerCase())) {
            containsSearchTerm.push(e)
          }
          searchResult = [...this.commonUtilty.sortObject('value', startWithSearchTerm, 'asc'),
          ...this.commonUtilty.sortObject('value', containsSearchTerm, 'asc')]
        }
      })

      let outputList = this.commonUtilty.getUniqueItems(searchResult, 'value')
      return outputList
    }
    else {
      let outputList = list ? list.slice(0, maxResultItems) : []
      return outputList
    }
  }

  getObjects(obj, key, val) {
    var objects = [];
    for (var i in obj) {
      if (!obj.hasOwnProperty(i)) continue;
      if (typeof obj[i] == 'object') {
        objects = objects.concat(this.getObjects(obj[i], key, val));
      } else
        //if key matches and value matches or if key matches and value is not passed (eliminating the case where key matches but passed value does not)
        if (i == key && obj[i] == val || i == key && val == '') { //
          objects.push(obj);
        } else if (obj[i] == val && key == '') {
          //only add if the object is not already in the array
          if (objects.lastIndexOf(obj) == -1) {
            objects.push(obj);
          }
        }
    }
    return objects;
  }



  /*  QUERY BUILDER */
  private _expression;
  private _validationObject
  public get expression() {
    return this._expression;
  }
  public set expression(value) {
    var parser = new DOMParser();
    var htmlDoc = parser.parseFromString(value, 'text/html');
    this._expression_text = this.preProcessExpression(htmlDoc.body.innerText)
    let removedSpecialCharacters = this.removedSpecialCharacters(this._expression_text, " ");
    let sanitizedExpression = this.sanitizeExpression(removedSpecialCharacters);
    // let doesFunctionHaveSpaces = this._doesFunctionHaveSpaces(sanitizedExpression);
    this._validationObject = this.validateExpression(sanitizedExpression)
    this.validationObject.emit(this._validationObject)
    this.refreshListOfInserts();

    if(htmlDoc.body && (htmlDoc.body.innerText.trim() == "" || htmlDoc.body.innerText == null)){
      this._expression = null;
    }else{
      this._expression = this.preProcessExpression(value);
    }
    if (value) {
      if (this._validationObject && this._validationObject.isValid && sanitizedExpression) {
        this.propagateChange(sanitizedExpression)
      }
      // else if (!environment.production) {
      //   this.propagateChange(sanitizedExpression)
      // }
    }
  }

  preProcessExpression(str) {
    // let output = this.capitalizeLogicalOperators(str);
    if (str == 'null')
      return null

    return str
  }

  sanitizeExpression(str) {
    //1. Only single space allowed
    try {
      if (str == 'null') {
        str = null
      }
      else if (str) {
        //1. Every Logical Operator should have spaces before and after it
        let logicalOperatorsToBeConsidered = ["THEN", "ELSE"]
        logicalOperatorsToBeConsidered.forEach((e, i) => {
          var matchRegex = new RegExp(e, "g");
          str = str.replace(matchRegex, ` ${e} `)
        })

        //2. Allow no double space
        str = str.replace(/\s{2,}/g, ' ');
        // str = str.replace(/  +/g, ' ') // Fallback Approach

        //3. Function should not have space in between
        // let allFunctions = getFromBetween.get(str, `${this.functionNameEndFragment}(`, ")");
        let allFunctions = this.getAllFunctions(str);
        if (this.commonUtilty.isArrayIterable(allFunctions)) {
          allFunctions.forEach(functionItem => {
            if (functionItem) {
              let spacesRemoved = functionItem.replace(/\s/g, '')
              str = str.replace(functionItem, spacesRemoved)
            }
          });
        }
      }
    }
    catch {
    }
    return str
  }

  private capitalizeLogicalOperators(str: any) {
    let logicalOperators = this.logicalOperators.map(e => e && e.value && e.value.replace(/[^a-zA-Z]+/g, ''));
    if (this.commonUtilty.isArrayIterable(logicalOperators)) {
      logicalOperators.forEach(operator => {
        var regex = new RegExp(operator + ' ', "gi");
        str = str.replace(regex, operator + ' ');
      });
    }
    return str;
  }

  get expressionInnerHTMLWithDescription() {
    let emittedExpression = this.replaceKeysWithValues(this.expression);
    this.expressionReadableText.emit(emittedExpression);
    return this.replaceKeysWithValues(this.expression);
  }

  get expressionTextWithDescriptions() {
    return this.replaceKeysWithValues(this._expression_text);
  }

  // @LiquidCache('expressionReplacement{value}', { duration: 18000 })
  private replaceKeysWithValues(value) {
    if (this.commonUtilty.isArrayIterable(this.allVocabularies) && value) {
      value = value.replace(/[\u200B-\u200D\uFEFF]/g, ' ');
      let valuesToReplace = this.commonUtilty.splitMulti(value, ["'", ">", "<" , " - "],["-"])
      valuesToReplace = this.commonUtilty.isArrayIterable(valuesToReplace) ? valuesToReplace.filter(e => e != "" && e && !this.isNumber(e) && (e.startsWith('#VC_') || e.startsWith('#FN_') || (e.startsWith("'") && e.endsWith("'")))) : []

      let lookupValues, functionValues
      try {
        lookupValues = getFromBetween.get(value, "'", "'")
        lookupValues = this.commonUtilty.isArrayIterable(lookupValues) ? lookupValues.filter(e => !this.isNumber(e)) : lookupValues
        // functionValues = getFromBetween.get(value, `${this.functionNameEndFragment}'`, "'")
        functionValues = this.getAllFunctions(value);
      }
      catch { }
      valuesToReplace = this.commonUtilty.uniquePushListInArray(valuesToReplace, lookupValues)
      if (this.commonUtilty.isArrayIterable(functionValues))
        valuesToReplace = valuesToReplace.filter(item => !functionValues.some(d => d == item))
      if (this.commonUtilty.isArrayIterable(valuesToReplace)) {
        valuesToReplace.forEach(valueToReplace => {
          var regex = new RegExp(valueToReplace, "g");
          if (valueToReplace.includes('#VC_'))
            value = value.replace(regex, (this.allVocabulariesMap[valueToReplace] || valueToReplace))
          else if (valueToReplace.includes('#FN_')) {
            value = value.replace(regex, (this.functionTypeMap[valueToReplace] || valueToReplace))
          }
          else if (this.lookupDataService.technicalLabelMap[valueToReplace])
            valueToReplace && (value = value.replace(regex, (this.lookupDataService.technicalLabelMap[valueToReplace] || valueToReplace)))
        });
      }
    }
    return value;
  }

  private _functionTypeMap;
  public get functionTypeMap() {
    let map = {}
    this.functionTypes.forEach(e => map[e.id] = e.value);
    return map
  }
  public set functionTypeMap(value) {
    this._functionTypeMap = value;
  }

  HTMLData
  _expression_text


  private refreshListOfInserts() {
    if (this.commonUtilty.isArrayIterable(this.insertedItemsList)) {
      this.insertedItemsList.forEach((item, index) => {
        if (this._expression_text && !this._expression_text.includes(item.value)) {
          this.insertedItemsList.splice(index, 1);
        }
      });
    }
  }

  get currentValidationMessage(): string {
    return this._validationObject ? this._validationObject.message : null
  }

  get currentValidationStatus(): boolean {
    return this._validationObject ? this._validationObject.isValid : null
  }





  config: QueryBuilderConfig = {
    fields: {
      age: { name: 'Age', type: 'number' },
      gender: {
        name: 'Gender',
        type: 'category',
        options: [
          { name: 'Male', value: 'm' },
          { name: 'Female', value: 'f' }
        ]
      }
    }
  };
  query: any =
    {
      "condition": "and",
      "rules": [
        {
          "field": "age",
          "operator": ">=",
          "value": 20
        },
        {
          "condition": "and",
          "rules": [
            {
              "field": "gender",
              "operator": "!=",
              "value": "m"
            }
          ]
        }
      ]
    };
  querytest = {
    condition: 'and',
    rules: [
      { field: 'age', operator: '<=', value: 'Bob' },
      { field: 'gender', operator: '>=', value: 'm' }
    ]
  };

  classNames: QueryBuilderClassNames = {
    /*removeIcon: 'fa fa-minus',
    addIcon: 'fa fa-plus',
    arrowIcon: 'fa fa-chevron-right px-2',
    button: 'btn',
    buttonGroup: 'btn-group',
    rightAlign: 'order-12 ml-auto',
    switchRow: 'd-flex px-2',
    switchGroup: 'd-flex align-items-center',
    switchRadio: 'custom-control-input',
    switchLabel: 'custom-control-label',
    switchControl: 'custom-control custom-radio custom-control-inline',
    row: 'row p-2 m-1',
    rule: 'border',
    ruleSet: 'border',
    invalidRuleSet: 'alert alert-danger',
    emptyWarning: 'text-danger mx-auto',
    operatorControl: 'form-control',
    operatorControlSize: 'col-auto pr-0',
    fieldControl: 'form-control',
    fieldControlSize: 'col-auto pr-0',
    entityControl: 'form-control',
    entityControlSize: 'col-auto pr-0',
    inputControl: 'form-control',
    inputControlSize: 'col-auto'*/
  };



  EmitComponentOutput(data) {
    this.componentOutput.emit(data)
  }


  validateExpression(msg, externalValidationFl?): { isValid, message } {
    let output = {
      isValid: true,
      message: ""
    };

    if (msg) {

      if (!this._isMatchingBrackets(msg)) output.message += "Please check brackets. ";

      if (!this._AreAllDependentStepsPresent(msg)) output.message += "The steps which are used in the expression are missing ";

      if (!this._noEmptyBracketsExist(msg)) output.message += "Empty brackets found. ";

      if (!this._AreSpecialCharactersValid(msg)) output.message += "Invalid Symbol used. ";

      if (!this._checkIFOperator(msg)) {
        output.message += "Invalid Operator Usage: IF & THEN both operator usage is mandatory if either of them or ELSE operator is used, or check if brackets are missing."
        this.setHelperInfo("Usage: IF(CONDITION) THEN (ACTION) ELSE (ACTION). Brackets are mandatory. ")
      }

      if (!this._allLogicalOperatorsInUpperCase(msg)) output.message += "Logical Operators should always be in uppercase";

      if (!this._valueAfterEveryOperator(msg)) output.message += "Value after operator missing. ";

      if (!this._noTwoVocabulariesWithOperatorsOrComma(this._expression_text)) output.message += "There should be an operator or a comma between two Vocabularies. Also make sure, there is either no space on both sides of comma or there is space on both sides of comma.";

      if (!this._noVC_$Issue(this._expression_text)) output.message += "Vocabulary cannot include '$' symbol";

      let isFunctionUsageValid = this._isFunctionUsageCorrect(msg)
      if (isFunctionUsageValid && !isFunctionUsageValid.isValid) {
        output.message += "Function not used properly. "
      }

      // let doesFunctionHaveSpaces = this._doesFunctionHaveSpaces(msg);
      // if (externalValidationFl.doesFunctionHaveSpaces && !externalValidationFl.doesFunctionHaveSpaces.isValid) {
      //   output.message += "Spaces are not allowed inside a function usage"
      // }

      if (this.appMetadataHandler.featureFlags && this.appMetadataHandler.featureFlags.enableBuildExpressionValidations) {
        output.isValid =
          this._isMatchingBrackets(msg) &&
          this._AreSpecialCharactersValid(msg) &&
          this._checkIFOperator(msg) &&
          this._noEmptyBracketsExist(msg) &&
          this._valueAfterEveryOperator(msg) &&
          this._allLogicalOperatorsInUpperCase(msg) &&
          this._AreAllDependentStepsPresent(msg) &&
          this._noTwoVocabulariesWithOperatorsOrComma(this._expression_text) &&
          this._noVC_$Issue(this._expression_text) &&
          // externalValidationFl.doesFunctionHaveSpaces.isValid &&
          // (!externalValidationFl || (externalValidationFl && externalValidationFl.doesFunctionHaveSpaces && externalValidationFl.doesFunctionHaveSpaces.isValid))
          (!isFunctionUsageValid || (isFunctionUsageValid && isFunctionUsageValid.isValid))
      }
      // if (output.isValid) this.resetHelpInfo()

      return output;
    }
    else {
      if (this.viewMode == 'micro') {
        output.isValid = false
        output.message = "Empty expression"
      }
      return output
    }
  }
  _AreAllDependentStepsPresent(msg: any) {
    if (msg)
      return msg && !msg.includes('$StepNotFound')
    else return true
  }

  _isBalanced(...str) {
    try {
      return (
        str.reduce((uptoPrevChar, thisChar) => {
          ((thisChar === "(" && uptoPrevChar++) || (thisChar === ")" && uptoPrevChar--)) &&
            ((thisChar === "{" && uptoPrevChar++) || (thisChar === "}" && uptoPrevChar--)) &&
            ((thisChar === "[" && uptoPrevChar++) || (thisChar === "]" && uptoPrevChar--));
          return uptoPrevChar;
        }, 0) === 0
      );
    }
    catch { }
  }

  _expressionExists(str) {
    return str && str != 'null'
  }

  _isMatchingBrackets(str) {
    let stack = {};
    let size = 0;
    let beginners = ['(', '[', '{'];
    let enders = [')', ']', '}'];
    for (var i = 0; i < str.length; i++) {
      if (beginners.indexOf(str[i]) !== -1) {
        stack[size] = str[i];
        size++;
      } else if (enders.indexOf(str[i]) !== -1) {
        if (size === 0) { return false; }
        var index = enders.indexOf(str[i]);
        if (stack[size - 1] === beginners[index]) {
          size--;
        } else {
          return false;
        }
      }
    }

    return size === 0;
  }

  _noEmptyBracketsExist(str) {
    try {
      let removedSpecialCharacters = str ? str.replace(/[\u200B-\u200D\uFEFF]/g, '') : str;
      if (removedSpecialCharacters.includes("(") && removedSpecialCharacters.includes(")")) {
        let allImmediateEnclosingBrackets = getFromBetween.get(removedSpecialCharacters, "(", ")");
        if (this.commonUtilty.isArrayIterable(allImmediateEnclosingBrackets)) {
          return !allImmediateEnclosingBrackets.some(e => (!e || e && !e.trim()))
        }
      }
      else return true
    }
    catch { return true }

  }

  /**
   * 
   * @param str 
   * @returns Boolean
   * Extremely specific handled here.
   */
  _valueAfterEveryOperator(str) {
    let removedSpecialCharacters = this.removedSpecialCharacters(str)
    let splitOutput
    try { splitOutput = this.commonUtilty.splitMulti(removedSpecialCharacters, [], ["_", "/", "-", ".", ","]).filter(e => e); }
    catch { }
    const mathOperators = this.allMathOperators.map(e => e.value)
    const operatorIndexes = splitOutput.map((r, indexInExpression) => {
      r && (r = r.trim())
      if (mathOperators.includes(r)) {
        return indexInExpression
      }
      else return null
    }).filter(d => d)

    if (operatorIndexes && this.commonUtilty.isArrayIterable(operatorIndexes)) {
      let valueAfterEveryOperator = operatorIndexes.every(operatorIndex => {
        return splitOutput[operatorIndex + 1] != "THEN" && (splitOutput.length - 1) != operatorIndex
      });

      return valueAfterEveryOperator
    }
    else {
      return true
    }

  }

  _noTwoVocabulariesWithOperatorsOrComma(msg) {
    let removedSpecialCharacters = this.removedSpecialCharacters(msg)
    let splitOutput = this.commonUtilty.splitMulti(removedSpecialCharacters, [], [","]) || [];
    if (this.commonUtilty.isArrayIterable(splitOutput)) {
      let vocabExtract = splitOutput.map((e, index) => e && e.includes('#VC_') ? e : null)
      let vocabulariesWithoutOperatorOrComma = vocabExtract.some((item, index, list) => list[index] && list[index + 1])
      return !vocabulariesWithoutOperatorOrComma
    }
    return true
  }

  _noVC_$Issue(msg) {
    let removedSpecialCharacters = this.removedSpecialCharacters(msg)
    let splitOutput = this.commonUtilty.splitMulti(removedSpecialCharacters, [], []) || [];
    if (this.commonUtilty.isArrayIterable(splitOutput)) {
      let vocabExtract = splitOutput.map((e, index) => e && e.includes('#VC_') && e.includes('$') ? e : null).filter(e => e)
      return !this.commonUtilty.isArrayIterable(vocabExtract)
    }
    return true
  }


  _isFunctionUsageCorrect(str) {
    let removedSpecialCharacters = str ? str.replace(/[\u200B-\u200D\uFEFF]/g, '') : str;
    // let allFunctions = getFromBetween.get(removedSpecialCharacters, `${this.functionNameEndFragment}(`, ")");
    let allFunctions = this.getAllFunctions(removedSpecialCharacters);
    if (this.commonUtilty.isArrayIterable(allFunctions)) {
      allFunctions = allFunctions.filter(e => e)
      let processedFunctionData = this.extractFunctionMetaDataFromSubstring(allFunctions)
      if (this.commonUtilty.isArrayIterable(processedFunctionData)) {
        let issues = processedFunctionData.map(functionMetadata => {
          // case 1: is Function used valid
          let functionInvalid = functionMetadata.functionName == 'INVALID'
          // case 2: number arguments are a match -- TODO Backend Dependency here

          // case 3: is anything used apartFromStep Variables, vocabularies, constants
          let invalidItemsUsed = functionMetadata.argList.filter(e => e && !((e.startsWith("'") && e.endsWith("'") || e.includes('#VC_') || e.includes('Step'))))

          // case 4: comma and argument number mismatch (Argument Missing)
          let argumentMissing = functionMetadata['numberOfArgs'] !== functionMetadata['commaCount']
          return { functionInvalid, invalidItemsUsed, argumentMissing, ...functionMetadata }
        })

        if (this.commonUtilty.isArrayIterable(issues)) {
          let output = issues.filter(e =>
            e.functionInvalid ||
            this.commonUtilty.isArrayIterable(e.invalidItemsUsed) ||
            e.argumentMissing
          )
          return { isValid: !this.commonUtilty.isArrayIterable(output), output }
        }

      }
      else {
        return { isValid: true }
      }
    }

  }

  _doesFunctionHaveSpaces(str) {
    // let removedSpecialCharacters = str ? str.replace(/[\u200B-\u200D\uFEFF]/g, '') : str;
    // let allFunctions = getFromBetween.get(str, `${this.functionNameEndFragment}(`, ")");
    let allFunctions = this.getAllFunctions(str);
    
    if (this.commonUtilty.isArrayIterable(allFunctions)) {
      allFunctions = allFunctions.filter(e => e)
      // let processedFunctionData = this.extractFunctionMetaDataFromSubstring(allFunctions)
      let noSpacesFoundInFunctions = allFunctions.every(functionUsed => {
        // case 5: no space allowed 
        return !(/\s/g.test(functionUsed));
      })
      return { isValid : noSpacesFoundInFunctions }
     
    } else {
      return { isValid: true }
    }

  }

  getAllFunctions(str) {
    let allFunctions = [...getFromBetween.get(str, `${this.numberFunctionNameEndFragment}(`, ")"),...getFromBetween.get(str, `${this.dateFunctionNameEndFragment}(`, ")")];
    return allFunctions;
  }

  private extractFunctionMetaDataFromSubstring(allFunctions: any) {
    return allFunctions.map(functionContent => {
      let splitOutput = this.commonUtilty.splitMulti(functionContent);
      if (this.commonUtilty.isArrayIterable(splitOutput)) {
        let functionUsed = splitOutput.shift();
        splitOutput = splitOutput.filter(e => e)
        functionUsed = functionUsed ? functionUsed.replace(/'/g, '') : functionUsed
        let messages = ""
        let functionName
        try {
          functionName = this.functions.find(e => e && e.id.toLowerCase() == functionUsed.toLowerCase()).id || "INVALID"
          messages = functionName ? messages : messages + `Invalid Function ${functionUsed} used.`
        } catch (e) {
          functionName = 'INVALID'
          messages = functionName ? messages : messages + `Invalid Function ${functionUsed} used.`
        }

        let item = {
          functionName,
          functionUsed
        };
        // splitOutput.forEach((functionArg, index) => {
        //   item[`arg${index + 1}`] = functionArg;
        // });

        item['numberOfArgs'] = splitOutput.length;
        item['argList'] = this.commonUtilty.deepCopy(splitOutput);
        item['commaCount'] = functionContent ? (functionContent.match(/,/g) || []).length : 0;

        return item;
      }
    });
  }

  _checkIFOperator(str) {
    const numberOfIFs = str.match(/IF\s/gi) || []
    const numberOfTHENs = str.match(/THEN\s\(/gi) || []
    const numberOfELSEs = str.match(/ELSE\s\(/gi) || []

    const condition1 = numberOfIFs.length == numberOfTHENs.length
    const condition2 = numberOfIFs.length >= numberOfELSEs.length
    /*const condition3 = this.commonUtilty.isArrayIterable(numberOfIFs) ? numberOfIFs.every(item => item && item == item.toUpperCase()) : true;
    const condition4 = this.commonUtilty.isArrayIterable(numberOfTHENs) ? numberOfTHENs.every(item => item && item == item.toUpperCase()) : true;
    const condition5 = this.commonUtilty.isArrayIterable(numberOfELSEs) ? numberOfELSEs.every(item => item && item == item.toUpperCase()) : true;*/

    return condition1 && condition2
  }

  _allLogicalOperatorsInUpperCase(msg) {
    msg = msg + " "
    let logicalOperators = this.logicalOperators.map(e => e && e.value && e.value.replace(/[^a-zA-Z]+/g, ''));
    let output
    if (this.commonUtilty.isArrayIterable(logicalOperators)) {
      output = logicalOperators.every((operator, index) => {
        var regex = new RegExp(' ' + operator + ' ', "gi");
        let foundMatches = msg.match(regex) || [];
        return this.commonUtilty.isArrayIterable(foundMatches) ? foundMatches.every(item => item && item == item.toUpperCase()) : true;
      });
    }
    return output;
  }

  _AreSpecialCharactersValid(msg) {
    let specialChar = msg.replace(/[\w\s]/gi, " ");
    specialChar = specialChar.replace(/'/gi, ""); //ignore these characters
    specialChar = this.sanitizeExpression(specialChar)
    let allSymbols = this.UtilGetUnique(specialChar);
    allSymbols = this.commonUtilty.isArrayIterable(allSymbols) ? allSymbols.filter(o => o) : allSymbols
    let supportedSymbols = ["(", "'", "<", ">", "*", ".", ")", "+", "-", "/", "==", ">=", "<=", "!=", "$", "#", ",", ";", "&", "|", "=", "!"];
    return allSymbols.every((v) => {
      if (v) v = v.trim()
      return supportedSymbols.indexOf(v) >= 0
    });
  }

  _AreOperatorsValid(msg) {
    let supportedOperators = ["IF", "THEN", "ELSE", "ELSE IF"];
    let words = this.UtilExtractWords(msg)
    let uniqueWord = Array.from(new Set(words));
    let exceptionWordRemoved = uniqueWord
      .map((e) => {
        if (!e.includes("VC")) return e;
        else return "%%";
      })
      .filter((f) => f !== "%%");
    let filterNumberics = this.UtilFilterNumbericValue(exceptionWordRemoved);
    let allOperators = this.UtilGetOperators(filterNumberics, msg);
    return allOperators.every((v) => supportedOperators.includes(v));
  }

  UtilGetUnique(str) {
    // return str.split(" ").filter((item, i, ar) => {
    //   return ar.indexOf(item) === i;
    // });

    try {
      str = str.trim();
      str = this.removedSpecialCharacters(str)
      str = str.replace(/\s/gi, "");
      let output = str.split('')
      return output.filter((item, i, ar) => {
        return ar.indexOf(item) === i;
      })
    }
    catch {
      return []
    }

  }

  isEmailAddress(str) {
    var pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return pattern.test(str);  // returns a boolean
  }
  isNotEmpty(str) {
    var pattern = /\S+/;
    return pattern.test(str);  // returns a boolean
  }
  isNumber(str) {
    var pattern = /^\d+$/;
    return pattern.test(str);  // returns a boolean
  }
  isSame(str1, str2) {
    return str1 === str2;
  }

  UtilExtractWords(string): string {
    return string.match(/\w+/g);
  }

  UtilFilterNumbericValue(arrayList) {
    return arrayList.filter((element) => isNaN(parseInt(element)));
  }

  UtilCheckIfAKeyWord(word, msg) {
    let sample = `'${word}'`;
    let spacesRemoved = msg.replace(/\s/g, "");
    return spacesRemoved.includes(sample);
  }

  UtilGetOperators(listOfWords, msg) {
    let finalList = listOfWords
      .map((w) => (!this.UtilCheckIfAKeyWord(w, msg) ? w : "%%"))
      .filter((e) => e !== "%%");

    return finalList;
  }



  /**
   * Cursor and complex String Manipulations
   * 
   * 
   *   @ViewChild("el", { static: false }) element: ElementRef;
  value = "Lorem ipsum dolor sit amet, consectetur adipiscing elit";

  _position;
  constructor() {}

  set position(value) {
    this._position = value;
  }
  get position() {
    if (this.element) {
      this._position = this.element.nativeElement.selectionStart;
      this.valueAfterCursor = this.value.substring(this._position);
      this.valueBeforeCursor = this.value.substring(0,this._position);
      return this._position;
    }
  }

  valueAfterCursor = this.value.substring(this.position);
  valueBeforeCursor = this.value.substring(0,this.position);

  @HostListener("window:keyup", ["$event"])
  @HostListener("click", ["$event"])
  setSelection(event) {
    if (event) {
      this.element.nativeElement.setSelectionRange(
        this.position,
        this.position,
        "none"
      );
    }
  }
   */



}

var getFromBetween = {
  results: [],
  string: "",
  getFromBetween: function (sub1, sub2) {
    if (this.string && (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0)) return false;
    var SP = this.string.indexOf(sub1) + sub1.length;
    var string1 = this.string.substr(0, SP);
    var string2 = this.string.substr(SP);
    var TP = string1.length + string2.indexOf(sub2);
    return this.string.substring(SP, TP);
  },
  removeFromBetween: function (sub1, sub2) {
    if (this.string && (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0)) return false;
    var removal = sub1 + this.getFromBetween(sub1, sub2) + sub2;
    this.string = this.string.replace(removal, "");
  },
  getAllResults: function (sub1, sub2) {
    // first check to see if we do have both substrings
    if (this.string && (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0)) return;

    // find one result
    var result = this.getFromBetween(sub1, sub2);
    // push it to the results array
    this.results.push(result);
    // remove the most recently found one from the string
    this.removeFromBetween(sub1, sub2);

    // if there's more substrings
    if (this.string && this.string.indexOf(sub1) > -1 && this.string.indexOf(sub2) > -1) {
      this.getAllResults(sub1, sub2);
    }
    else return;
  },
  get: function (string, sub1, sub2) {
    this.results = [];
    this.string = string || "";
    this.getAllResults(sub1, sub2);
    return this.results;
  }
};

